import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { safeReturnUrl } from './return-url';

export const guestGuard: CanActivateFn = (route) => {
    const auth = inject(AuthService);
    if (!auth.isAuthenticated()) {
        return true;
    }

    const router = inject(Router);
    return router.parseUrl(safeReturnUrl(route.queryParamMap.get('returnUrl')));
};
